// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  h5 {
      color: rgb(7, 6, 6);
      padding: 10px;
  }
.CacolCatPara{
    display: inline-block;
    min-height: 50px;
      background: #fff;
}
  .Cacol {
    display: inline-flex;
    min-height: 50px;
      background: #fff;
      /* border-bottom: 0.9px solid rgb(178, 219, 252); */

  }

  .blockEl {
      margin-top: 40px;
      padding-bottom: 20px;
      background: white;
      box-shadow: 5px 5px 15px -5px rgba(0, 0, 0, 0.3);
      overflow: hidden;
  }

  .boxCategory {
      max-width: 500px;
      margin: 50px auto;
      background: white;
      border-radius: 5px;
      box-shadow: 5px 5px 15px -5px rgba(0, 0, 0, 0.3);
  }

  /* #heading {
    background-color: #A683E3;
    text-align: center;
  } */

  .itemCategory {
      min-height: 30px;
      margin: 0px auto;
      display: flex;
      align-items: center;
      border-bottom: 1px solid rgb(108, 183, 245);
  }

  .itemCategory:last-child {
      border-bottom: 0;
  }

  /* .inputCategory:checked+p {
      text-decoration: line-through;
      text-decoration-color: #A683E3;
  } */

  .inputCategory[type="checkbox"] {
      margin: 20px;
  }

  .p {
      margin: 0;
      padding: 20px;
      font-size: 20px;
      font-weight: 200;
      color: #00204a;
  }

  form.itemCategory {
      text-align: center;
      margin-left: 20px;
  }

  .dellCategory {
      color: black;
      min-height: 30px;
      width: 30px;
      font-size: 20px;
      margin: 4px 6px 6px 20px;
  }

  .AddCategory {
      height: 50px;
      width: 50px;
      border-radius: 50%;
      border-color: transparent;
      text-align: "center";
      background-color: rgb(143, 188, 240);
      color: #fff;
      font-size: 30px;
      padding: 0;
      border-width: 1px;
  }

  .inputCategory[type="text"] {
      text-align: center;
      height: 60px;
      top: 10px;
      border: none;
      background: transparent;
      font-size: 20px;
      font-weight: 200;
      width: 313px;
  }

  .inputCategory[type="text"]:focus {
      outline: none;
      box-shadow: inset 0 -3px 0 0 rgb(143, 188, 240);
  }

  ::placeholder {
      color: grey;
      opacity: 1;
  }

.inputCategoryFil[type="checkbox"] {
    margin: 10px;
}

.inputCategoryFil[type="text"] {
    /* text-align: center; */
    height: 35px;
    top: 10px;
    border: none;
    background: transparent;
    font-size: 20px;
    font-weight: 200;
    width: 313px;
}

.inputCategoryFil[type="text"]:focus {
    outline: none;
    box-shadow: inset 0 -3px 0 0 rgb(143, 188, 240);
}`, "",{"version":3,"sources":["webpack://./src/includes/pages/category.css"],"names":[],"mappings":"EAAE;MACI,mBAAmB;MACnB,aAAa;EACjB;AACF;IACI,qBAAqB;IACrB,gBAAgB;MACd,gBAAgB;AACtB;EACE;IACE,oBAAoB;IACpB,gBAAgB;MACd,gBAAgB;MAChB,mDAAmD;;EAEvD;;EAEA;MACI,gBAAgB;MAChB,oBAAoB;MACpB,iBAAiB;MACjB,gDAAgD;MAChD,gBAAgB;EACpB;;EAEA;MACI,gBAAgB;MAChB,iBAAiB;MACjB,iBAAiB;MACjB,kBAAkB;MAClB,gDAAgD;EACpD;;EAEA;;;KAGG;;EAEH;MACI,gBAAgB;MAChB,gBAAgB;MAChB,aAAa;MACb,mBAAmB;MACnB,2CAA2C;EAC/C;;EAEA;MACI,gBAAgB;EACpB;;EAEA;;;KAGG;;EAEH;MACI,YAAY;EAChB;;EAEA;MACI,SAAS;MACT,aAAa;MACb,eAAe;MACf,gBAAgB;MAChB,cAAc;EAClB;;EAEA;MACI,kBAAkB;MAClB,iBAAiB;EACrB;;EAEA;MACI,YAAY;MACZ,gBAAgB;MAChB,WAAW;MACX,eAAe;MACf,wBAAwB;EAC5B;;EAEA;MACI,YAAY;MACZ,WAAW;MACX,kBAAkB;MAClB,yBAAyB;MACzB,oBAAoB;MACpB,oCAAoC;MACpC,WAAW;MACX,eAAe;MACf,UAAU;MACV,iBAAiB;EACrB;;EAEA;MACI,kBAAkB;MAClB,YAAY;MACZ,SAAS;MACT,YAAY;MACZ,uBAAuB;MACvB,eAAe;MACf,gBAAgB;MAChB,YAAY;EAChB;;EAEA;MACI,aAAa;MACb,+CAA+C;EACnD;;EAEA;MACI,WAAW;MACX,UAAU;EACd;;AAEF;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,+CAA+C;AACnD","sourcesContent":["  h5 {\n      color: rgb(7, 6, 6);\n      padding: 10px;\n  }\n.CacolCatPara{\n    display: inline-block;\n    min-height: 50px;\n      background: #fff;\n}\n  .Cacol {\n    display: inline-flex;\n    min-height: 50px;\n      background: #fff;\n      /* border-bottom: 0.9px solid rgb(178, 219, 252); */\n\n  }\n\n  .blockEl {\n      margin-top: 40px;\n      padding-bottom: 20px;\n      background: white;\n      box-shadow: 5px 5px 15px -5px rgba(0, 0, 0, 0.3);\n      overflow: hidden;\n  }\n\n  .boxCategory {\n      max-width: 500px;\n      margin: 50px auto;\n      background: white;\n      border-radius: 5px;\n      box-shadow: 5px 5px 15px -5px rgba(0, 0, 0, 0.3);\n  }\n\n  /* #heading {\n    background-color: #A683E3;\n    text-align: center;\n  } */\n\n  .itemCategory {\n      min-height: 30px;\n      margin: 0px auto;\n      display: flex;\n      align-items: center;\n      border-bottom: 1px solid rgb(108, 183, 245);\n  }\n\n  .itemCategory:last-child {\n      border-bottom: 0;\n  }\n\n  /* .inputCategory:checked+p {\n      text-decoration: line-through;\n      text-decoration-color: #A683E3;\n  } */\n\n  .inputCategory[type=\"checkbox\"] {\n      margin: 20px;\n  }\n\n  .p {\n      margin: 0;\n      padding: 20px;\n      font-size: 20px;\n      font-weight: 200;\n      color: #00204a;\n  }\n\n  form.itemCategory {\n      text-align: center;\n      margin-left: 20px;\n  }\n\n  .dellCategory {\n      color: black;\n      min-height: 30px;\n      width: 30px;\n      font-size: 20px;\n      margin: 4px 6px 6px 20px;\n  }\n\n  .AddCategory {\n      height: 50px;\n      width: 50px;\n      border-radius: 50%;\n      border-color: transparent;\n      text-align: \"center\";\n      background-color: rgb(143, 188, 240);\n      color: #fff;\n      font-size: 30px;\n      padding: 0;\n      border-width: 1px;\n  }\n\n  .inputCategory[type=\"text\"] {\n      text-align: center;\n      height: 60px;\n      top: 10px;\n      border: none;\n      background: transparent;\n      font-size: 20px;\n      font-weight: 200;\n      width: 313px;\n  }\n\n  .inputCategory[type=\"text\"]:focus {\n      outline: none;\n      box-shadow: inset 0 -3px 0 0 rgb(143, 188, 240);\n  }\n\n  ::placeholder {\n      color: grey;\n      opacity: 1;\n  }\n\n.inputCategoryFil[type=\"checkbox\"] {\n    margin: 10px;\n}\n\n.inputCategoryFil[type=\"text\"] {\n    /* text-align: center; */\n    height: 35px;\n    top: 10px;\n    border: none;\n    background: transparent;\n    font-size: 20px;\n    font-weight: 200;\n    width: 313px;\n}\n\n.inputCategoryFil[type=\"text\"]:focus {\n    outline: none;\n    box-shadow: inset 0 -3px 0 0 rgb(143, 188, 240);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
